<template>
  <div>
    <sidebar-menu v-model:collapsed="collapsed" :menu="dummyMenu" :show-one-child="true" class="v-sidebar-menu"
                  width="280px"/>
    <div id="demo" :class="[{ collapsed: collapsed }, { onmobile: isOnMobile }]">
      <div class="demo">
        <Header :show-search-bar-only="showSearchOnHeaderOnly" :showHeaderTitle="collapsed"></Header>
        <div style="padding: 10px">
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./partial/Header";
import dashboard from "@/services/dashboard.service";
import {h} from 'vue'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import SidebarMenu from "@/components/CustomSidebar/components/SidebarMenu.vue";
import Config from "@/config";
import SystemSettingsService from "@/services/system-settings.service";

const faIcon = (props) => {
  return {
    element: h('div', [h(FontAwesomeIcon, {...props})]),
  }
}
export default {
  name: "LayoutDashboard",

  components: {
    Header,
    SidebarMenu
  },
  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize);
  },
  async created() {
    this.imageBasePath = Config.apiFileBasePath;
    await this.getSystemSettings();
    this.getMenus();
  },
  data() {
    return {
      company_short_name: '',
      system_settings: null,
      admin_cms_logo: '',
      imageBasePath: '',
      inActiveColor: null,
      activeColor: '#4e73df',
      side_menu: [],
      dummyMenu: [],
      collapsed: false,
      isOnMobile: false,
      showSearchOnHeaderOnly: false,
    };
  },
  methods: {
    // onToggleCollapse(collapsed) {
    //   console.log('onToggleCollapse')
    //   console.log('collapsed', collapsed)
    // },
    // onItemClick(event, item) {
    //   console.log('onItemClick')
    //   console.log(event)
    //   console.log(item)
    // },
    onResize() {
      if (window.innerWidth <= 767) {
        this.isOnMobile = true;
        this.collapsed = true;
        this.showSearchOnHeaderOnly = true;
      } else {
        this.isOnMobile = false;
        this.collapsed = false;
        this.showSearchOnHeaderOnly = false;
      }
    },
    async getSystemSettings() {
      try {
        const response = await SystemSettingsService.getSystemSettings();
        if (response.data) {
          this.system_settings = response.data;
          const adminCmsLogoObj = response.data.find(item => item.system_key === "admin_cms_logo");
          this.admin_cms_logo = adminCmsLogoObj ? adminCmsLogoObj.value : null;
          const company_short_name_obj = response.data.find(item => item.system_key === "company_short_name");
          this.company_short_name = company_short_name_obj ? company_short_name_obj.value : null;
          const show_cms_search_bar_obj = response.data.find(item => item.system_key === "show_cms_search_bar");
          const show_cms_search_bar = show_cms_search_bar_obj ? show_cms_search_bar_obj.value : null;
          localStorage.setItem('show_cms_search_bar', show_cms_search_bar);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getMenus() {
      try {
        const response = await dashboard.getMenus();
        if (response.data) {
          this.side_menu = response.data;
          const sidebars = new Set();
          const sidebarWithName = new Set();

          this.side_menu.sort(this.sortMenu);
          // header image and title
          this.dummyMenu.push(
              {
                header: this.company_short_name + ' CMS',
                hiddenOnCollapse: true,
                titleImage: this.imageBasePath + this.admin_cms_logo,
              },
          );
          //saving sidebars for routing access control
          this.side_menu.forEach(sidebarMenu => {
            const myArray = sidebarMenu.main_menu_icon.split('"');
            if (sidebarMenu.child != null) {
              // if sidebar option is a dropdown, add it's children's paths
              var childMenus = [];
              sidebarMenu.child.forEach(submenu => {
                childMenus.push(
                    {
                      href: submenu.menu_url,
                      title: submenu.menu_name,
                    }
                )
                sidebars.add(submenu.menu_url);
                sidebarWithName.add(
                    {
                      title: submenu.menu_name,
                      url: submenu.menu_url,
                      icon: submenu.menu_icon,
                    }
                );
              });
              this.dummyMenu.push(
                  {
                    title: sidebarMenu.main_menu_name,
                    child: childMenus,
                    icon: faIcon({icon: myArray[1]}),
                  }
              );
            } else {
              this.dummyMenu.push(
                  {
                    href: sidebarMenu.main_menu_url,
                    title: sidebarMenu.main_menu_name,
                    icon: faIcon({icon: myArray[1]}),
                  }
              );
              sidebars.add(sidebarMenu.main_menu_url);
              sidebarWithName.add(
                  {
                    title: sidebarMenu.main_menu_name,
                    url: sidebarMenu.main_menu_url,
                    icon: sidebarMenu.main_menu_icon,
                  }
              );
            }
          });
          localStorage.setItem('permitted_routes', JSON.stringify(Array.from(sidebars)));
          localStorage.setItem('permitted_routes_with_names', JSON.stringify(Array.from(sidebarWithName)));

          // this.$store.dispatch("routes/setPermittedRoutes", Array.from(sidebars));
        }
      } catch (error) {
        console.log(error);
      }

    },
    sortMenu(a, b) {
      return a.serial_no - b.serial_no;
    },

  },

};
</script>

<style scoped>

#demo {
  padding-left: 280px;
  transition: 0.3s ease;
}

#demo.collapsed {
  padding-left: 65px;
}

#demo.onmobile {
  padding-left: 65px;
}
</style>
